import ActionType from 'actions/ActionType'

export default (state = '', action) => {
  switch (action.type) {
    case ActionType.Campaign.CHANGE_NEW_STAGE_NAME:
      return action.payload
    default:
      return state
  }
}
